import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397b3b63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/logo.jpg",
    alt: "SmartAdmin WebApp",
    "aria-roledescription": "logo"
  })
], -1))
const _hoisted_3 = {
  id: "js-primary-nav",
  class: "primary-nav",
  role: "navigation"
}
const _hoisted_4 = {
  id: "js-nav-menu",
  class: "nav-menu"
}
const _hoisted_5 = {
  class: "nav-link-text",
  "data-i18n": "nav.blankpage"
}
const _hoisted_6 = {
  key: 0,
  class: "badge badge-icon position-relative ml-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "売上管理")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/jyutyuinput" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.utilities_menu_child"
  }, "受注情報入力")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "受注情報検索", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "売上検索", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "仕入検索", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "未承認一覧", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "入金確定表", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "請求一覧", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "請求No検索", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "データロック", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "帳票作成")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "請求書作成", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "請求書作成(売上なし)", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "文書管理", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "月次報告管理書作成", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "取引先別売上表作成", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "仕入先別支払表作成", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "広告主別売上表作成", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "月次報告分割一覧表作成", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "売上請求書一覧表作成", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "発行請求書一覧表作成", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "入金予定表作成", -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "支払予定表作成", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "マスタ情報管理")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "商品マスタ管理", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "売上先マスタ管理", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i19n": "nav.utilities_menu_child"
}, "仕入先マスタ管理", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i20n": "nav.utilities_menu_child"
}, "社員マスタ管理", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i21n": "nav.utilities_menu_child"
}, "口座マスタ管理", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i22n": "nav.utilities_menu_child"
}, "掲示板マスタ管理", -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i23n": "nav.utilities_menu_child"
}, "目標マスタ管理", -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i22n": "nav.utilities_menu_child"
}, "休日管理", -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i24n": "nav.utilities_menu_child"
}, "操作履歴", -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "申請書管理")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "申請書一覧", -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "勤怠管理")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "勤怠管理", -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "出勤表", -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  title: "Category",
  "data-filter-tags": "category"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nav-link-text",
    "data-i18n": "nav.category"
  }, "データ管理")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "データポータル", -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link-text",
  "data-i18n": "nav.utilities_menu_child"
}, "データ診断", -1))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-message js-filter-message bg-success-600" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/dashboard', $event)))
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode("ダッシュボード "),
              (0 < _ctx.alertCount.alertCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.alertCount.alertCount), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.showFlags.showSales_2)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_7,
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showProject_100)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showProjectsearch_101)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('/ankenlist', $event)))
                      }, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSalessearch_102)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('/uriagelist', $event)))
                      }, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSuppliersearch_103)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goTo('/shiirelist', $event)))
                      }, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showUnapproved_104)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goTo('/misyoninlist', $event)))
                      }, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showDeposited_105)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goTo('/nyukinyoteilist', $event)))
                      }, _hoisted_19)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showClaimsearch_106)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 6,
                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goTo('/seikyulist', $event)))
                      }, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showClaimnum_107)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 7,
                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goTo('/seikyunolist', $event)))
                      }, _hoisted_23)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showLock_108)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 8,
                      onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goTo('/datalocklist', $event)))
                      }, _hoisted_25)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showReport_3)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              onClick: _cache[43] || (_cache[43] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_26,
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showClaim_109)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goTo('/seikyusyocreate', $event)))
                      }, _hoisted_28)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showClaimnosale_110)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.goTo('/seikyusyocreatenotsales', $event)))
                      }, _hoisted_30)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", {
                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goTo('/doclist', $event)))
                  }, _hoisted_32)
                ]),
                (_ctx.showFlags.showReportgetuji_111)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.goTo('/getujikanricreate', $event)))
                      }, _hoisted_34)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReporttorihikisaki_112)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.goTo('/torihikiuriagecreate', $event)))
                      }, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReportsiire_130)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goTo('/shiireshiharaicreate', $event)))
                      }, _hoisted_38)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReportkoukokunusi_113)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.goTo('/koukokuuriagecreate', $event)))
                      }, _hoisted_40)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReportgetujibunkatu_114)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 6,
                      onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.goTo('/getujibunkatsucreate', $event)))
                      }, _hoisted_42)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReporturiage_115)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 7,
                      onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.goTo('/uriageseikyucreate', $event)))
                      }, _hoisted_44)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReporthakkou_116)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 8,
                      onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.goTo('/hakkoseikyucreate', $event)))
                      }, _hoisted_46)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReportnyuukinn_117)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 9,
                      onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.goTo('/nyukinyoteicreate', $event)))
                      }, _hoisted_48)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showReportsiharai_118)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 10,
                      onClick: _cache[42] || (_cache[42] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.goTo('/paymentyoteicreate', $event)))
                      }, _hoisted_50)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showMaster_4)
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              onClick: _cache[62] || (_cache[62] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_51,
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showItem_127)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[45] || (_cache[45] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.goTo('/syouhinlist', $event)))
                      }, _hoisted_53)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showClient_119)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goTo('/uriagesakilist', $event)))
                      }, _hoisted_55)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSupplier_120)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.goTo('/shiiresakilist', $event)))
                      }, _hoisted_57)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showStaff_121)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.goTo('/syainlist', $event)))
                      }, _hoisted_59)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showBank_122)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.goTo('/kouzalist', $event)))
                      }, _hoisted_61)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showMessage_123)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[55] || (_cache[55] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.goTo('/messagelist', $event)))
                      }, _hoisted_63)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showGoal_124)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 6,
                      onClick: _cache[57] || (_cache[57] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.goTo('/salestargetlist', $event)))
                      }, _hoisted_65)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showHolidaylist_131)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 7,
                      onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.goTo('/holidaylist', $event)))
                      }, _hoisted_67)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showHistory_125)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 8,
                      onClick: _cache[61] || (_cache[61] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.goTo('/sousarirekilist', $event)))
                      }, _hoisted_69)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showRequest_5)
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              onClick: _cache[65] || (_cache[65] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_70,
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onClick: _cache[64] || (_cache[64] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.goTo('/shinseisyolist', $event)))
                  }, _hoisted_72)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showAttendance_7)
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              onClick: _cache[70] || (_cache[70] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_73,
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showAttendancelist_128)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[67] || (_cache[67] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.goTo('/attendancelist', $event)))
                      }, _hoisted_75)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showAttendanceedit_129)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.goTo('/attendanceedit', $event)))
                      }, _hoisted_77)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showDataportal_6)
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              onClick: _cache[75] || (_cache[75] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _hoisted_78,
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showsalesanaly_126)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[72] || (_cache[72] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.goTo('/analyprofit2', $event)))
                      }, _hoisted_80)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showsalesanaly_126)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[74] || (_cache[74] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.goTo('/datadiagnosis', $event)))
                      }, _hoisted_82)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_83
    ])
  ]))
}